import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSportsBasketball = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSportsBasketball",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M82-521q5-51 21-96t44-86q35 36 59 84t30 98zm642 0q7-51 30-98t59-83q28 39 44 85t21 96zM147-258q-28-39-44-84t-21-97h154q-7 51-30 98t-59 83m666 0q-36-36-59-83t-30-98h154q-5 50-21 96t-44 85M317-521q-8-72-39-133t-81-110q48-48 110-77t132-37v357zm204 0v-357q71 8 133 37t109 77q-51 48-81 110t-39 133zM439-82q-72-8-133-37t-109-78q51-48 82-109t38-133h122zm82 0v-357h122q8 72 39 134t81 109q-48 48-109 77T521-82"
  })
}));
IconSportsBasketball.displayName = 'IconSportsBasketball';